// extracted by mini-css-extract-plugin
export default {"prompt-main":"PromptSection_prompt-main__rMAq5","prompt":"PromptSection_prompt__rzl9I","is-selected":"PromptSection_is-selected__bgurM","icon":"PromptSection_icon__gnWp-"};